/*
Author: Liubo
Date: 2018-09-05
Desc: Vue 路由配置
*/
import Vue from "vue";
import Router from "vue-router";
import util from "@/util";

Vue.use(Router);
export default new Router({
    // mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "login",
            meta: { requiresAuth: false, nameText: "登录" },
            component: () => import(/* webpackChunkName: "login" */ "./views/common/dynaView.vue")
        },
        // 钱柜
        {
            path: "*",
            redirect: "/"
        },
        {
            path: "/frame",
            name: "frame",
            meta: { requiresAuth: true, nameText: "顶层frame" },
            component: () => import(/* webpackChunkName: "frame" */ "./views/common/frame.vue"),
            children: [
                {
                    path: "/home",
                    name: "home",
                    meta: {
                        requiresAuth: true,
                        nameText: "我的资产",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                    }, // 检查用户信息 1用户是否绑定交易账户，2用户必须完善信息，3用户交易必须完善信息
                    component: () =>
                        import(/* webpackChunkName: "home" */ "./views/common/dynaView.vue")
                },
                // 持仓详情
                {
                    path: "/assetsDetail",
                    name: "assetsDetail",
                    meta: {
                        requiresAuth: true,
                        nameText: "持仓详情",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "assetsDetail" */ "./views/common/dynaView.vue")
                },
                // 组合投资持仓详情
                {
                    path: "/comboAssetsDetail",
                    name: "comboAssetsDetail",
                    meta: {
                        requiresAuth: true,
                        nameText: "持仓情况",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "assetsDetail" */ "./views/common/dynaView.vue")
                },
                // 适当性处理
                {
                    path: "/warnList",
                    name: "warnList",
                    meta: {
                        requiresAuth: true,
                        nameText: "适当性处理",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "assetsDetail" */ "./views/common/dynaView.vue")
                },
                // 钱柜
                {
                    path: "/moneybox",
                    name: "moneybox",
                    meta: {
                        requiresAuth: true,
                        nameText: "现金宝",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1,2" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "moneybox" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/autoaccess",
                    name: "autoaccess",
                    meta: {
                        requiresAuth: true,
                        nameText: "现金宝",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "autoaccess" */ "./views/common/dynaView.vue")
                },
                // 现金宝
                {
                    path: "/currencyfund",
                    name: "currencyfund",
                    meta: {
                        requiresAuth: true,
                        nameText: "现金宝推荐",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "currencyfund" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/currencyfund/mycurrency",
                    name: "mycurrency",
                    meta: {
                        requiresAuth: true,
                        nameText: "现金宝资产",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "mycurrency" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/currencyfund/currencycharge",
                    name: "currencycharge",
                    meta: {
                        requiresAuth: true,
                        nameText: "现金宝充值",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,3" }
                        }
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "currencycharge" */ "./views/common/dynaView.vue"
                        )
                },
                {
                    path: "/currencyfund/currencyredemption",
                    name: "currencyredemption",
                    meta: {
                        requiresAuth: true,
                        nameText: "现金宝取现",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,3" }
                        }
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "currencyredemption" */ "./views/common/dynaView.vue"
                        )
                },
                {
                    path: "/currencyfund/currencyplan",
                    name: "currencyplan",
                    meta: {
                        requiresAuth: true,
                        nameText: "现金宝定期定投",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,3" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "currencyplan" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/currencyfund/autoextractor",
                    name: "autoextractor",
                    meta: {
                        requiresAuth: true,
                        nameText: "现金宝定期取出",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,3" }
                        }
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "autoextractor" */ "./views/common/dynaView.vue"
                        )
                },
                // 安全中心
                {
                    path: "/securitycenter",
                    name: "securitycenter",
                    meta: { requiresAuth: true, nameText: "安全中心" },
                    component: () =>
                        import(
                            /* webpackChunkName: "securitycenter" */ "./views/common/dynaView.vue"
                        )
                },
                {
                    path: "/securitycenter/changeqpwd",
                    name: "changeqpwd",
                    meta: { requiresAuth: true, nameText: "修改查询密码" },
                    component: () =>
                        import(/* webpackChunkName: "changeqpwd" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/securitycenter/changelpwd",
                    name: "changelpwd",
                    meta: {
                        requiresAuth: true,
                        nameText: "修改登录密码",
                        tit: "修改密码",
                        menuHidden: true
                    },
                    component: () =>
                        import(/* webpackChunkName: "changelpwd" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/securitycenter/changetpwd",
                    name: "changetpwd",
                    meta: {
                        requiresAuth: true,
                        nameText: "修改交易密码",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "changetpwd" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/securitycenter/bindacctway",
                    name: "bindacctway",
                    meta: { requiresAuth: true, nameText: "绑定交易账户" },
                    component: () =>
                        import(/* webpackChunkName: "bindacctway" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/securitycenter/bindoldacct",
                    name: "bindoldacct",
                    meta: { requiresAuth: true, nameText: "绑定已有交易账户" },
                    component: () =>
                        import(/* webpackChunkName: "bindoldacct" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/securitycenter/bindnewacct",
                    name: "bindnewacct",
                    meta: {
                        requiresAuth: true,
                        nameText: "绑定新交易账户",
                        tit: "实名认证",
                        menuHidden: true
                    },
                    component: () =>
                        import(/* webpackChunkName: "bindnewacct" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/securitycenter/bindmobile",
                    name: "bindmobile",
                    meta: { requiresAuth: true, nameText: "绑定手机号" },
                    component: () =>
                        import(/* webpackChunkName: "bindmobile" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/securitycenter/changemobile",
                    name: "changemobile",
                    meta: { requiresAuth: true, nameText: "更换手机号" },
                    component: () =>
                        import(/* webpackChunkName: "changemobile" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/securitycenter/checkmobile",
                    name: "checkmobile",
                    meta: { requiresAuth: true, nameText: "检查手机号" },
                    component: () =>
                        import(/* webpackChunkName: "checkmobile" */ "./views/common/dynaView.vue")
                },
                // 用户信息
                {
                    path: "/info",
                    name: "info",
                    meta: {
                        requiresAuth: true,
                        nameText: "用户信息",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "info" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/risk",
                    name: "risk",
                    meta: {
                        requiresAuth: true,
                        nameText: "风险信息",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "risk" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/info/risktest",
                    name: "risktest",
                    meta: {
                        requiresAuth: true,
                        nameText: "风险评测",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "risktest" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/info/infocollection",
                    name: "infocollection",
                    meta: {
                        requiresAuth: true,
                        nameText: "适当性信息",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "infocollection" */ "./views/common/dynaView.vue"
                        )
                },
                {
                    path: "/info/taxeslist",
                    name: "taxeslist",
                    meta: {
                        requiresAuth: true,
                        nameText: "税收信息列表",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "taxeslist" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/taxesinfo",
                    name: "taxesinfo",
                    meta: {
                        requiresAuth: true,
                        nameText: "税收信息",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "taxesinfo" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/policyAndLaw",
                    name: "policyAndLaw",
                    meta: {
                        requiresAuth: true,
                        nameText: "政策法规",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "policyAndLaw" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/acctManager",
                    name: "acctManager",
                    meta: {
                        requiresAuth: true,
                        nameText: "账户管理",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1,2" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "acctManager" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/invchange",
                    name: "invchange",
                    meta: {
                        requiresAuth: true,
                        nameText: "投资者类型转换",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "invchange" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/invdetail",
                    name: "invdetail",
                    meta: {
                        requiresAuth: true,
                        nameText: "投资者类型转换",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "invchange" */ "./views/common/dynaView.vue")
                },

                {
                    path: "/infoCollection",
                    name: "infoCollection",
                    meta: {
                        requiresAuth: true,
                        nameText: "投资者信息补录",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "infoCollection" */ "./views/common/dynaView.vue"
                        )
                },
                {
                    path: "/info/invknowledgetest",
                    name: "invknowledgetest",
                    meta: {
                        requiresAuth: true,
                        nameText: "投资者知识评测",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "invknowledgetest" */ "./views/common/dynaView.vue"
                        )
                },
                {
                    path: "/info/invdataup",
                    name: "invdataup",
                    meta: {
                        requiresAuth: true,
                        nameText: "投资者文件上传",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "invdataup" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/info/modifyinfo",
                    name: "modifyinfo",
                    meta: {
                        requiresAuth: true,
                        nameText: "修改用户信息",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "modifyinfo" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/info/checkacct",
                    name: "checkacct",
                    meta: {
                        requiresAuth: true,
                        nameText: "完善用户信息",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "checkacct" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/info/ocrinfoupd",
                    name: "ocrinfoupd",
                    meta: {
                        requiresAuth: true,
                        nameText: "更新证件信息",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "ocrinfoupd" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/info/acctinfologin",
                    name: "acctinfologin",
                    meta: {
                        requiresAuth: true,
                        nameText: "账户登录记录"
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "acctinfologin" */ "./views/common/dynaView.vue"
                        )
                },
                {
                    path: "/info/acctinfopwdmodify",
                    name: "acctinfopwdmodify",
                    meta: {
                        requiresAuth: true,
                        nameText: "密码修改记录"
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "acctinfopwdmodify" */ "./views/common/dynaView.vue"
                        )
                },
                // 绑定/解绑微信
                {
                    path: "/info/wxbindchange",
                    name: "wxbindchange",
                    meta: {
                        requiresAuth: true,
                        nameText: "绑定/解绑微信"
                    },
                    component: () =>
                        import(/* webpackChunkName: "wxbindchange" */ "./views/common/dynaView.vue")
                },
                // 汇款地址信息
                {
                    path: "/info/remitinfo",
                    name: "remitinfo",
                    meta: {
                        requiresAuth: true,
                        nameText: "汇款地址信息"
                    },
                    component: () =>
                        import(/* webpackChunkName: "remitinfo" */ "./views/common/dynaView.vue")
                },
                // 基金信息
                {
                    path: "/fund",
                    name: "fund",
                    meta: {
                        requiresAuth: true,
                        nameText: "基金列表",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "fund" */ "./views/common/dynaView.vue")
                },
                // {
                //     path: "/privatefundList",
                //     name: "privatefundList",
                //     meta: {
                //         requiresAuth: true,
                //         nameText: "高端理财专区",
                //         requiresCheck: {func: util.checkAcct, params: {checkCate: "2"}}
                //     },
                //     component: () =>
                //                 import ( /* webpackChunkName: "fund" */ "./views/common/dynaView.vue")
                // },
                // 基金信息
                {
                    path: "/oldCombofund",
                    name: "oldCombofund",
                    meta: {
                        requiresAuth: true,
                        nameText: "组合基金",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "oldCombofund" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/optionalfund",
                    name: "optionalfund",
                    meta: {
                        requiresAuth: true,
                        nameText: "自选组合基金",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "optionalfund" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/fund/buyfund",
                    name: "buyfund",
                    meta: {
                        requiresAuth: true,
                        nameText: "买基金",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,3" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "buyfund" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/fund/sellfund",
                    name: "sellfund",
                    meta: {
                        requiresAuth: true,
                        nameText: "基金赎回",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,3" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "sellfund" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/cfund",
                    name: "cfund",
                    meta: {
                        requiresAuth: true,
                        nameText: "基金转换列表",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "cfund" */ "./views/common/dynaView.vue")
                },
                // 预约基金信息
                {
                    path: "/orderfund",
                    name: "orderfund",
                    meta: {
                        requiresAuth: true,
                        nameText: "预约基金列表",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "orderfund" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/orderbuyfund",
                    name: "orderbuyfund",
                    meta: {
                        requiresAuth: true,
                        nameText: "预约买基金",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,3" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "orderbuyfund" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/myorder",
                    name: "myorder",
                    meta: {
                        requiresAuth: true,
                        nameText: "我的预约",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "myorder" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/orderselllist",
                    name: "orderselllist",
                    meta: {
                        requiresAuth: true,
                        nameText: "预约赎回列表",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "2" }
                        }
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "orderselllist" */ "./views/common/dynaView.vue"
                        )
                },
                {
                    path: "/fund/ordersell",
                    name: "ordersell",
                    meta: {
                        requiresAuth: true,
                        nameText: "预约赎回",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "ordersell" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/fund/changefundDc",
                    name: "changefund",
                    meta: {
                        requiresAuth: true,
                        nameText: "基金转换",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,3" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "changefund" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/fund/changefundDc",
                    name: "sellBuyFund",
                    meta: {
                        requiresAuth: true,
                        nameText: "赎回转申购",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,3" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "changefund" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/fund/trusteeshipFund",
                    name: "trusteeshipFund",
                    meta: {
                        requiresAuth: true,
                        nameText: "跨系统转托管",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,3" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "changefund" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/fund/transferCombTrusteeIn",
                    name: "transferCombTrusteeIn",
                    meta: {
                        requiresAuth: true,
                        nameText: "转托管入直销",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,3" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "changefund" */ "./views/common/dynaView.vue")
                },
                /* 交易记录 */
                // {
                //     path: "/tradeHistory",
                //     name: "tradeHistory",
                //     meta: {
                //         requiresAuth: true,
                //         nameText: "交易记录",
                //         requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                //     },
                //     component: () =>
                //         import(/* webpackChunkName: "traderecord" */ "./views/common/dynaView.vue")
                // },
                /* 交易记录 */
                {
                    path: "/traderecord",
                    name: "traderecord",
                    meta: {
                        requiresAuth: true,
                        nameText: "交易记录",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "traderecord" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/hkresult",
                    name: "hkresult",
                    meta: {
                        requiresAuth: true,
                        nameText: "汇款结果页",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "resetrade" */ "./components/fund/hkResult.vue")
                },
                /* 快速交易 */
                {
                    path: "/quickTrade",
                    name: "quickTrade",
                    meta: {
                        requiresAuth: true,
                        nameText: "快速交易",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "quickTrade" */ "./views/common/dynaView.vue")
                },
                /* 交易记录 */
                /* 分红信息明细 */
                {
                    path: "/dividendInfo",
                    name: "dividendInfo",
                    meta: {
                        requiresAuth: true,
                        nameText: "分红信息明细"
                        // requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "dividendInfo" */ "./views/common/dynaView.vue")
                },
                /* 分红信息明细 */
                /* 账户查询 */
                {
                    path: "/accountSearch",
                    name: "accountSearch",
                    meta: {
                        requiresAuth: true,
                        nameText: "账户查询" /* ,
                requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } } */
                    },
                    component: () =>
                        import(/* webpackChunkName: "账户查询" */ "./views/common/dynaView.vue")
                },
                /* 账户查询 */
                {
                    path: "/etflist",
                    name: "etflist",
                    meta: {
                        requiresAuth: true,
                        nameText: "补券信息"
                    },
                    component: () =>
                        import(/* webpackChunkName: "etflist" */ "./views/common/dynaView.vue")
                },
                /* 盈亏查询 */
                {
                    path: "/profitqry",
                    name: "profitqry",
                    meta: {
                        requiresAuth: true,
                        nameText: "盈亏查询"
                    },
                    component: () =>
                        import(/* webpackChunkName: "profitqry" */ "./views/common/dynaView.vue")
                },
                /* 定投 */
                {
                    path: "/gfund",
                    name: "gfund",
                    meta: { requiresAuth: true, nameText: "定投基金列表" },
                    component: () =>
                        import(/* webpackChunkName: "gfund" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/gfund/glist",
                    name: "glist",
                    meta: { requiresAuth: true, nameText: "基金定投菜单" },
                    component: () =>
                        import(/* webpackChunkName: "glist" */ "./views/common/dynaView.vue")
                },
                // 基金信息
                {
                    path: "/gfund/combogeneral",
                    name: "combogeneral",
                    meta: {
                        requiresAuth: true,
                        nameText: "组合基金",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "combogeneral" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/gfund/optionalgeneral",
                    name: "optionalgeneral",
                    meta: {
                        requiresAuth: true,
                        nameText: "自选组合基金",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "optionalgeneral" */ "./views/common/dynaView.vue"
                        )
                },
                {
                    path: "/gfund/generalbuy",
                    name: "generalbuy",
                    meta: {
                        requiresAuth: true,
                        nameText: "基金定投",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2,3" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "generalbuy" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/gfund/generalchange",
                    name: "generalchange",
                    meta: {
                        requiresAuth: true,
                        nameText: "基金定投修改",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2,3" }
                        }
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "generalchange" */ "./views/common/dynaView.vue"
                        )
                },
                {
                    path: "/gfund/generalrecovery",
                    name: "generalrecovery",
                    meta: {
                        requiresAuth: true,
                        nameText: "基金定投恢复",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2,3" }
                        }
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "generalrecovery" */ "./views/common/dynaView.vue"
                        )
                },
                {
                    path: "/gfund/wisdombuy",
                    name: "wisdombuy",
                    meta: {
                        requiresAuth: true,
                        nameText: "智慧定投",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2,3" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "wisdombuy" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/myplan",
                    name: "myplan",
                    meta: {
                        requiresAuth: true,
                        nameText: "持有定投",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "myplan" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/home/plandetail",
                    name: "plandetail",
                    meta: {
                        requiresAuth: true,
                        nameText: "定投详情",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "plandetail" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/planCalculator",
                    name: "planCalculator",
                    meta: {
                        requiresAuth: true,
                        nameText: "定投计算器",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "planCalculator" */ "./views/common/dynaView.vue"
                        )
                },
                /* 私募、专户理财基金 */
                {
                    path: "/private",
                    name: "private",
                    meta: {
                        requiresAuth: true,
                        nameText: "专户/私募基金",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "private" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/privatefund/privatebuy",
                    name: "privatebuy",
                    meta: {
                        requiresAuth: true,
                        nameText: "专户/私募基金购买",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2,3" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "privatebuy" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/privatefund",
                    name: "privatefund",
                    meta: { requiresAuth: true, nameText: "持有专户/私募基金" },
                    component: () =>
                        import(/* webpackChunkName: "privatefund" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/private/privateupload",
                    name: "privateupload",
                    meta: {
                        requiresAuth: true,
                        nameText: "合格投资者认证",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "privateupload" */ "./views/common/dynaView.vue"
                        )
                },
                /* 信息披露 */
                {
                    path: "/infoPublish",
                    name: "infoPublish",
                    meta: {
                        requiresAuth: true,
                        nameText: "信息披露",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "infoPublish" */ "./views/common/dynaView.vue")
                },
                /* 公告详情 */
                {
                    path: "/knowdetail",
                    name: "knowdetail",
                    meta: {
                        requiresAuth: true,
                        nameText: "公告详情",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "knowdetail" */ "./views/common/dynaView.vue")
                },
                // 服务定制
                {
                    path: "/service",
                    name: "service",
                    meta: {
                        requiresAuth: true,
                        nameText: "服务定制"
                    },
                    component: () =>
                        import(/* webpackChunkName: "service" */ "./views/common/dynaView.vue")
                },
                // 对账单信息
                {
                    path: "/statement",
                    name: "statement",
                    meta: {
                        requiresAuth: true,
                        nameText: "对账单信息"
                    },
                    component: () =>
                        import(/* webpackChunkName: "statement" */ "./views/common/dynaView.vue")
                },
                // 身份证号位数转换
                {
                    path: "/idnumbertran",
                    name: "idnumbertran",
                    meta: {
                        requiresAuth: true,
                        nameText: "身份证号位数转换",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "idnumbertran" */ "./views/common/dynaView.vue")
                },
                // 银行信息
                {
                    path: "/signandunsign",
                    name: "signandunsign",
                    meta: {
                        requiresAuth: true,
                        nameText: "签约解约银行卡",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "signandunsign" */ "./views/common/dynaView.vue"
                        )
                },
                {
                    path: "/changecard",
                    name: "changecard",
                    meta: {
                        requiresAuth: true,
                        nameText: "换卡",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "changecard" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/changecardlist",
                    name: "changecardlist",
                    meta: {
                        requiresAuth: true,
                        nameText: "换卡申请记录",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "changecardlist" */ "./views/common/dynaView.vue"
                        )
                },
                {
                    path: "/bank",
                    name: "bank",
                    meta: {
                        requiresAuth: true,
                        nameText: "持有银行卡",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "bank" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/bank/addbank",
                    name: "addbank",
                    meta: {
                        requiresAuth: true,
                        nameText: "新增银行卡",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "addbank" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/bank/signbank",
                    name: "signbank",
                    meta: {
                        requiresAuth: true,
                        nameText: "签约银行卡",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "signbank" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/bank/unsignbank",
                    name: "unsignbank",
                    meta: {
                        requiresAuth: true,
                        nameText: "解约银行卡",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "unsignbank" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/bank/changebank",
                    name: "changebank",
                    meta: {
                        requiresAuth: true,
                        nameText: "更换银行卡",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "changebank" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/bank/activebank",
                    name: "activebank",
                    meta: {
                        requiresAuth: true,
                        nameText: "激活银行卡",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "activebank" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/bank/modifybank",
                    name: "modifybank",
                    meta: {
                        requiresAuth: true,
                        nameText: "修改银行卡",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "modifybank" */ "./views/common/dynaView.vue")
                },
                {
                    path: "trade/resetrade",
                    name: "tradepwd",
                    meta: { requiresAuth: true, nameText: "重置交易密码" },
                    component: () =>
                        import(/* webpackChunkName: "tradepwd" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/sdxtext",
                    name: "sdxtext",
                    meta: {
                        requiresAuth: true,
                        nameText: "证券期货投资者适当性管理办法",
                        requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                    },
                    component: () =>
                        import(/* webpackChunkName: "risk" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/agreement",
                    name: "agreement",
                    meta: {
                        requiresAuth: true,
                        nameText: "协议列表",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "activebank" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/contract",
                    name: "contract",
                    meta: {
                        requiresAuth: true,
                        nameText: "合同列表",
                        requiresCheck: {
                            func: util.checkAcct,
                            params: { checkCate: "1,2" }
                        }
                    },
                    component: () =>
                        import(/* webpackChunkName: "idnumbertran" */ "./views/common/dynaView.vue")
                },

                // 高端理财
                {
                    path: "/financial/management",
                    name: "financialManagement",
                    meta: { requiresAuth: true, nameText: "高端理财" },
                    component: () =>
                        import(/* webpackChunkName: "glist" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/fundManagement/list",
                    name: "fundFanagementList",
                    meta: { requiresAuth: true, nameText: "产品列表" },
                    component: () =>
                        import(/* webpackChunkName: "glist" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/financial/notice",
                    name: "fundNotice",
                    meta: { requiresAuth: true, nameText: "产品公告" },
                    component: () =>
                        import(/* webpackChunkName: "glist" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/financial/fundnav",
                    name: "fundNav",
                    meta: { requiresAuth: true, nameText: "产品净值" },
                    component: () =>
                        import(/* webpackChunkName: "glist" */ "./views/common/dynaView.vue")
                }
            ]
        },
        {
            path: "/outframe",
            name: "outframe",
            redirect: "/regresult",
            meta: { requiresAuth: false, nameText: "外层frame" },
            component: () =>
                import(/* webpackChunkName: "outframe" */ "./views/common/outFrame.vue"),
            children: [
                {
                    path: "/errGeneral",
                    name: "errgeneral",
                    meta: { requiresAuth: false, nameText: "系统错误" },
                    component: () =>
                        import(/* webpackChunkName: "errgeneral" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/errNetwork",
                    name: "errnetwork",
                    meta: { requiresAuth: false, nameText: "网络错误" },
                    component: () =>
                        import(/* webpackChunkName: "errnetwork" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/register",
                    name: "register",
                    meta: { requiresAuth: false, nameText: "登录", tit: "欢迎注册！" },
                    component: () =>
                        import(/* webpackChunkName: "register" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/resetpwdway",
                    name: "resetpwdway",
                    meta: { requiresAuth: false, nameText: "重置密码选择" },
                    component: () =>
                        import(/* webpackChunkName: "resetpwdway" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/resetlogin",
                    name: "resetlogin",
                    meta: { requiresAuth: false, nameText: "重置注册密码", tit: "忘记密码" },
                    component: () =>
                        import(/* webpackChunkName: "resetlogin" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/retrievepwd",
                    name: "retrievepwd",
                    meta: { requiresAuth: false, nameText: "找回密码", tit: "忘记密码" },
                    component: () =>
                        import(/* webpackChunkName: "resetlogin" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/wxbind",
                    name: "wxbind",
                    meta: { requiresAuth: false, nameText: "微信绑定" },
                    component: () =>
                        import(/* webpackChunkName: "wxbind" */ "./views/common/dynaView.vue")
                },
                {
                    path: "/resetrade",
                    name: "resetrade",
                    meta: { requiresAuth: false, nameText: "重置交易密码" },
                    component: () =>
                        import(/* webpackChunkName: "resetrade" */ "./views/common/dynaView.vue")
                }
            ]
        }
    ]
});
